<div class="flex flex-col !items-center justify-between">
  <br />
  <div class="mat-elevation-z2 w-4/5 min-w-[600px] p-5">
    <table class="m-0 w-full">
      @if (filteredEmployees.length > 0) {
        <tr class="primary-color h-[50px]">
          <th class="pl-2 text-left">Employees</th>
          <th class="w-12">ST</th>
          <th class="w-12">OT</th>
          <th class="w-12">DT</th>
          <th>Daily Total</th>
          <th>
            Weekly<br />
            Total
          </th>
        </tr>
      }
      @for (emp of filteredEmployees; track emp) {
        <tr class="row-height">
          @for (value of emp.getGraphableValues(); track $index) {
            <td notranslate [ngClass]="{ 'pl-3 !text-left': $first }">
              {{ value }}
            </td>
          }
        </tr>
      }
      @if (filteredEquipment.length > 0) {
        <tr class="primary-color h-[50px]">
          <th class="pl-2 text-left">Equipment</th>
          <th>Hours</th>
          <th colspan="2"></th>
          <th>Daily Total</th>
          <th>
            Weekly<br />
            Total
          </th>
        </tr>
      }
      @for (entity of filteredEquipment; track entity) {
        <tr class="row-height">
          @for (value of entity.getGraphableValues(); track $index) {
            <td notranslate [ngClass]="{ 'pl-3 !text-left': $first }">
              {{ value }}
            </td>
          }
        </tr>
      }

      @for (eqp of timeSheet.currentEquipmentProduction; track eqp) {
        <tr class="row-height">
          @for (value of eqp.getGraphableValues(); track $index) {
            <td notranslate [ngClass]="{ 'pl-3 !text-left': $first }">
              {{ value }}
            </td>
          }
        </tr>
      }
      @if (timeSheet.currentQuantityProduction.length === 0) {
        <tr class="primary-color h-[50px]">
          <th class="pl-2 text-left">Production</th>
          <th colspan="3"></th>
          <th>Quantity</th>
          <th>Weekly<br />Total</th>
        </tr>
      }
      @for (prd of timeSheet.currentQuantityProduction; track prd) {
        <tr class="row-height">
          @for (value of prd.getGraphableValues(); track $index) {
            <td [ngClass]="{ 'pl-3 !text-left': $first }">
              {{ value }}
            </td>
          }
        </tr>
      }
    </table>

    <table class="!m-0 w-full">
      @for (txt of timeSheet.currentTextProduction; track txt) {
        @if ($first) {
          <tr class="primary-color h-[50px] text-left">
            <th colspan="7" class="pl-2">Production Text</th>
          </tr>
        }
        <tr class="row-height min-h-[40px]">
          @for (value of txt.getGraphableValues(); track $index) {
            <ng-container class="text-left">
              @if ($first) {
                <td notranslate class="w-44 pl-3 !text-left">{{ value }}</td>
              }
              @if ($index === 1) {
                <td class="!text-left" notranslate>{{ value }}</td>
              }
            </ng-container>
          }
        </tr>
      }
    </table>
  </div>
  <div class="flex w-full justify-center py-8">
    <button mat-raised-button class="!h-12" [disabled]="isUploading" (click)="upload()">
      <span>Submit</span>
      <mat-icon class="ml-1 content-center !text-2xl" [inline]="true">send</mat-icon>
    </button>
  </div>
</div>
